import request from '@/utils/request'
 // 查询报检需求
 export function apiPageInspectionRequired (query) {
    return request({
      url: `/scp/scpMpsPlans/findPageInspectionRequired`,
      method: 'get',
      params: query
    })
  }
   // 查询报检需求
 export function apiPageInspectionAdjust (query) {
  return request({
    url: `/scp/scpMpsPlans/findPageInspectionAdjust`,
    method: 'get',
    params: query
  })
}
   // 查询净需求
   export function apiPageNetDemand (query) {
    return request({
      url: `/scp/scpMpsPlans/findPageNetDemand`,
      method: 'get',
      params: query
    })
  }
